import React from 'react';

const MapSection = () => {
  return (
    <section className='wpo-map-section'>
      <h2 className='hidden'>Contact map</h2>
      <div className='wpo-map'>
        <iframe
          title='Ferry Gold Shipping Office Location'
          loading='lazy'
          referrerPolicy='no-referrer-when-downgrade'
          src='https://www.google.com/maps?q=Yau%20Lee%20Centre%2C%20UNIT%2078%2C%203%2FF%2C%2045%20Hoi%20Yuen%20Rd%2C%20Kwun%20Tong%2C%20Hong%20Kong&output=embed'
        ></iframe>
      </div>
    </section>
  );
};

export default MapSection;
